<template>
  <div id="ylNewsSearch">
    <ylNewsSearchMobile
      v-if="isMobileScreen"
      v-bind="$attrs"
       />
    <ylNewsSearchPC
      v-else
      v-bind="$attrs"
       />
  </div>
</template>
<script>
export default {
  name: "ylNewsSearch",
  components: {
    ylNewsSearchMobile: () => import("./components/mobile.vue"),
    ylNewsSearchPC: () => import("./components/pc.vue"),
  },
  data() {
    return {};
  },
  computed: {
    screenWidth() {
      return this.$store.getters.screenWidth;
    },
    screenHeight() {
      return this.$store.getters.screenHeight;
    },
    isMobileScreen() {
      return this.$store.getters.isMobileScreen;
    },
  },
  created() {},
  methods: {},
};
</script>